export default __webpack_public_path__ + "static/media/WhatsApp Community_Century.cf0627a0.png";